const PageHeader = () => {
  const activeSearchClass = 'has-active-search-bar'
  const toggleSearch = document.querySelector('.js-toggle-search-bar')
  const closeSearch = document.querySelector('.js-close-search-bar')
  const searchInput = document.querySelector('.js-search-input')

  const headerToggle = document.querySelector('.js-toggle-nav')
  const body = document.body
  const activeNavClass = 'nav-is-active'

  // Toggle search on/off
  if (toggleSearch) {
    toggleSearch.addEventListener('click', (e) => {
      e.preventDefault()
      // Remove main nav class
      body.classList.toggle(activeSearchClass)
      if (searchInput) { searchInput.focus() }
    })
  }

  if (closeSearch) {
    closeSearch.addEventListener('click', (e) => {
      e.preventDefault()
      body.classList.remove(activeSearchClass)
    })
  }

  body.addEventListener('click', function (e) {
    if (this.classList.contains(activeSearchClass) && e.target === this) {
      body.classList.remove(activeSearchClass)
    }
  })

  headerToggle.addEventListener('click', () => {
    body.classList.toggle(activeNavClass)
  })
}

export default PageHeader



// WEBPACK FOOTER //
// ./src/js/modules/PageHeader.js